import { FoldDownPlainObject } from '../plainObjects/folddown.plainObject';
import { ColumnMapVisitor } from './columnMap.visitor';

/* eslint-disable @typescript-eslint/no-explicit-any */
export class FoldDownVisitor extends ColumnMapVisitor {
    protected get _transformation(): FoldDownPlainObject {
        return this.transformation as FoldDownPlainObject;
    }

    public visitTransformation(transformationContext: any): void {
        super.visitTransformation(transformationContext);
    }

    public visitFunctionExpr(context: any): any {
        if (context.basicFunction().basicName().getText() === 'unroll') {
            const expressions = context.basicFunction().expression();
            if (expressions.length === 2) {
                this._transformation.unrollBy = expressions[0].getText();
                this._transformation.unrollRoot = expressions[1].getText();
            } else if (expressions.length === 1) {
                this._transformation.unrollBy = expressions[0].getText();
            }
        } else if (context.basicFunction().basicName().getText() === 'unrollMultiple') {
            super.visitFunctionExpr(context);
            (context.basicFunction().expression() as any[]).forEach((expression) => {
                if (!expression.basicFunction) {
                    this._transformation.unrollMultiple.push(expression.getText());
                }
            });
            this._transformation.rules.forEach((rule) => this._transformation.columns.push(rule));
            this._transformation.rules = [];
            this._transformation.mappings = [];
        } else {
            super.visitFunctionExpr(context);
        }
    }
}
